<template>
  <div v-loading="loading" class="vehicle-config-details">
    <div class="header-section">
      <div v-if="vehModelDetail.title" class="config-content-title1">
        {{ vehModelDetail.title.join(" > ") }}
      </div>
      <div v-if="vehModelDetail.vinCode" class="config-content-title2 mt-2">车架号：{{ vehModelDetail.vinCode }}</div>
      <div v-if="vehModelDetail.remark" class="config-content-title3 mt-2 flex items-center">
        <svg
          t="1727404686234"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3552"
          width="18"
          height="18"
          class="mr-2"
        >
          <path
            d="M512 992C246.912 992 32 777.088 32 512 32 246.912 246.912 32 512 32c265.088 0 480 214.912 480 480 0 265.088-214.912 480-480 480zM480 256v352a32 32 0 0 0 64 0V256a32 32 0 0 0-64 0z m-16 528a48 48 0 1 0 96 0 48 48 0 0 0-96 0z"
            p-id="3553"
            fill="#02A7F0"
          ></path>
        </svg>
        <span>{{ vehModelDetail.remark }}</span>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="config-nav">
        <div
          v-for="(nav, i) in configNavList"
          :key="nav.id"
          class="config-nav-item"
          :class="configNavActive === nav.id ? 'config-nav-item-active' : ''"
          @click="changeConfigNavActive(nav, i)"
        >
          <span>{{ nav.name }}</span>
          <div class="nav-indicator"></div>
        </div>
      </div>

      <div class="config-content">
        <div
          v-if="configTable.length > 4"
          ref="configContentTableRef"
          class="config-content-table"
          @scroll="scrollConfigTable"
        >
          <table>
            <template v-for="(tr, rowIndex) in configTable">
              <tr :key="rowIndex" :id="tr.id || ''">
                <template v-if="tr.type === 'title'">
                  <th v-for="(col, colIndex) in tr.list" :key="colIndex">
                    {{ col.name }}
                  </th>
                </template>
                <template v-else>
                  <td v-for="(col, colIndex) in tr.list" :key="colIndex" :class="col.type === 'title' ? 'title' : ''">
                    <template v-if="col.tips">
                      <div class="flex items-center justify-end cursor-pointer">
                        <el-tooltip effect="dark" :content="col.tips" placement="top">
                          <svg
                            t="1727421131746"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="2312"
                            width="16"
                            height="16"
                          >
                            <path
                              d="M1024 512a512 512 0 1 0-512 512 512 512 0 0 0 512-512z m-647.68-119.04h-71.68a340.48 340.48 0 0 1 15.36-103.68 185.6 185.6 0 0 1 46.08-64 207.36 207.36 0 0 1 70.4-40.96A243.2 243.2 0 0 1 512 170.24a212.48 212.48 0 0 1 144.64 51.2 172.8 172.8 0 0 1 57.6 135.68 170.24 170.24 0 0 1-14.08 69.12 309.76 309.76 0 0 1-62.72 76.8 532.48 532.48 0 0 0-64 66.56 128 128 0 0 0-24.32 46.08 236.8 236.8 0 0 0 0 72.96H473.6a384 384 0 0 1 7.68-85.76 273.92 273.92 0 0 1 21.76-55.04 318.72 318.72 0 0 1 56.32-70.4l64-66.56a87.04 87.04 0 0 0 16.64-64 106.24 106.24 0 0 0-33.28-76.8A128 128 0 0 0 512 236.8c-88.32 0-135.68 52.48-135.68 156.16zM471.04 768h83.2v88.32h-83.2z"
                              fill="#02A7F0"
                              p-id="2313"
                            ></path>
                          </svg>
                        </el-tooltip>
                        <span class="ml-2">{{ col.name }}</span>
                      </div>
                    </template>
                    <template v-else>{{ col.name }}</template>
                  </td>
                </template>
              </tr>
            </template>
          </table>
        </div>

        <div v-if="configTable.length === 4" class="no-data-container">
          <svg
            t="1730285697037"
            class="icon"
            viewBox="0 0 1561 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6225"
            width="256"
            height="256"
          >
            <path
              d="M156.16 699.763h21.03a10.432 10.432 0 0 1 10.202 10.445c0 5.76-4.48 10.445-10.202 10.445h-21.03v21.094a10.432 10.432 0 0 1-10.406 10.24 10.227 10.227 0 0 1-10.42-10.24V720.64h-21.03a10.432 10.432 0 0 1-10.202-10.445c0-5.76 4.48-10.445 10.202-10.445h21.03v-21.094c0.128-5.683 4.736-10.24 10.42-10.24 5.747 0 10.406 4.506 10.406 10.24v21.107z m1374.208-83.558V595.11a10.291 10.291 0 0 0-10.406-10.24 10.432 10.432 0 0 0-10.42 10.24v21.095h-21.03a10.24 10.24 0 0 0-10.202 10.445c0 5.593 4.583 10.444 10.202 10.444h21.03v21.095c0 5.747 4.672 10.24 10.42 10.24a10.432 10.432 0 0 0 10.406-10.24v-21.095h21.03a10.266 10.266 0 0 0 10.202-10.444 10.432 10.432 0 0 0-10.202-10.445h-21.03zM773.965 960.858h-524.16a20.757 20.757 0 0 1-14.72-6.106 20.915 20.915 0 0 1 14.707-35.66h94.426a83.213 83.213 0 0 1-11.072-41.678V271.45a83.528 83.528 0 0 1 24.448-59.072 83.085 83.085 0 0 1 58.918-24.384h62.374v-20.992a83.629 83.629 0 0 1 24.448-59.06 83.085 83.085 0 0 1 58.932-24.384h499.532a83.046 83.046 0 0 1 58.944 24.372 83.584 83.584 0 0 1 24.436 59.072v605.964a83.251 83.251 0 0 1-11.098 41.677h115.174c11.52 0 20.852 9.28 20.852 20.89 0 11.52-9.268 20.89-20.826 20.89H999.424v20.991a83.251 83.251 0 0 1-11.098 41.677h11.162c11.456 0 20.762 9.267 20.762 20.877 0 11.533-9.434 20.89-20.762 20.89H889.946a41.754 41.754 0 0 1-6.4 50.867 41.472 41.472 0 0 1-58.88 0l-50.688-50.867z m76.134-41.767h66.202c22.912 0 41.472-18.598 41.472-41.881V270.464c0-22.566-17.984-40.704-40.18-40.704H414.977c-22.195 0-40.18 18.227-40.18 40.704V877.21c0 23.116 18.74 41.881 41.46 41.881h316.032l-10.7-10.752a41.78 41.78 0 0 1-10.817-40.384l-19.66-19.737a145.46 145.46 0 0 1-197.261-21.581c-49.984-57.895-46.976-144.666 6.886-198.938 54.029-54.4 140.8-57.6 198.656-7.321 57.869 50.265 67.11 136.883 21.158 198.297l19.674 19.738a41.408 41.408 0 0 1 40.256 10.841l69.606 69.837z m149.325-104.448h62.656a41.728 41.728 0 0 0 41.446-41.779v-605.76c0-23.142-18.56-41.78-41.446-41.78H561.971a41.728 41.728 0 0 0-41.433 41.78v20.89h395.52a83.046 83.046 0 0 1 58.93 24.37 83.584 83.584 0 0 1 24.436 59.086v543.193zM265.472 47.002h31.027c8.743 0 15.821 6.95 15.821 15.667a15.744 15.744 0 0 1-15.82 15.667h-31.028v31.104c0 8.78-6.938 15.872-15.616 15.872a15.693 15.693 0 0 1-15.616-15.872V78.336h-31.027a15.654 15.654 0 1 1 0-31.334h31.027v-31.13C234.24 7.104 241.178 0 249.856 0c8.614 0 15.616 7.104 15.616 15.872v31.13zM20.826 939.968c0-11.52 9.433-20.877 20.748-20.877H166.63c11.456 0 20.762 9.267 20.762 20.877 0 11.533-9.434 20.89-20.762 20.89H41.574a20.772 20.772 0 0 1-14.707-6.106 20.838 20.838 0 0 1-6.041-14.784zM677.44 804.954a104.691 104.691 0 0 0 26.957-100.903 104.294 104.294 0 0 0-73.626-73.856A103.898 103.898 0 0 0 530.19 657.23c-40.653 40.793-40.653 106.931 0 147.712a103.885 103.885 0 0 0 147.251 0zM458.074 313.318c0-11.52 9.305-20.864 20.8-20.876H707.93c11.494 0 20.812 9.344 20.812 20.876a20.864 20.864 0 0 1-20.812 20.89H478.886a20.736 20.736 0 0 1-14.732-6.093 20.864 20.864 0 0 1-6.08-14.797z m0 104.448c0-11.52 9.267-20.89 20.672-20.89h333.44a20.736 20.736 0 0 1 20.672 20.89c0 11.52-9.268 20.89-20.685 20.89h-333.44a20.8 20.8 0 0 1-20.672-20.89z m0 104.448c0-11.532 9.28-20.89 20.774-20.89h145.83c11.482 0 20.788 9.268 20.788 20.878 0 11.532-9.293 20.89-20.788 20.89h-145.83a20.672 20.672 0 0 1-14.72-6.106 20.838 20.838 0 0 1-6.054-14.784z m-395.61-125.35A62.426 62.426 0 0 1 8.371 365.53a62.848 62.848 0 0 1 0-62.656 62.426 62.426 0 0 1 54.093-31.335c34.496 0 62.464 28.058 62.464 62.656 0 34.611-27.968 62.669-62.464 62.669z m0-31.334a31.178 31.178 0 0 0 27.046-15.668 31.424 31.424 0 0 0 0-31.334 31.22 31.22 0 0 0-58.278 15.68 31.283 31.283 0 0 0 31.232 31.334z m1290.918-93.99c-34.496 0-62.464-28.058-62.464-62.67 0-34.61 27.968-62.668 62.464-62.668s62.464 28.057 62.464 62.668c0 34.612-27.968 62.67-62.464 62.67z m0-31.335c11.162 0 21.479-5.978 27.06-15.667a31.424 31.424 0 0 0 0-31.335 31.22 31.22 0 0 0-58.279 15.667 31.283 31.283 0 0 0 31.232 31.335z"
              fill="#bfbfbf"
              p-id="6226"
            ></path>
          </svg>
          <span class="no-data-text">暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { vehicleModelApi } from "@/api/goods";

export default {
  name: "VehicleConfigDetails",
  data() {
    return {
      configContentTableRef: null,
      configNavActive: "nav1",
      configNavList: [
        { id: "nav1", name: "基本参数" },
        { id: "nav2", name: "车身参数" },
        { id: "nav3", name: "发动机参数" },
        { id: "nav4", name: "变速箱/底盘/车轮配置" }
      ],
      configTable: [
        {
          type: "title",
          id: "nav1",
          list: [
            { type: "title", name: "基本参数" },
            { type: "title", name: "" },
            { type: "title", name: "" },
            { type: "title", name: "" }
          ]
        },
        {
          type: "title",
          id: "nav2",
          list: [
            { type: "title", name: "车身参数" },
            { type: "title", name: "" },
            { type: "title", name: "" },
            { type: "title", name: "" }
          ]
        },
        {
          type: "title",
          id: "nav3",
          list: [
            { type: "title", name: "发动机参数" },
            { type: "title", name: "" },
            { type: "title", name: "" },
            { type: "title", name: "" }
          ]
        },
        {
          type: "title",
          id: "nav4",
          list: [
            { type: "title", name: "变速箱/底盘/车轮配置" },
            { type: "title", name: "" },
            { type: "title", name: "" },
            { type: "title", name: "" }
          ]
        }
      ],
      configTableTHOffsetTop: [],
      isChangeConfigNavActive: false,
      vin: "",
      vmid: "",
      service: "",
      queryData: {},
      loading: false,
      vehModelDetail: {
        bodyKeys: [],
        bodyValues: [],
        brandClass: "",
        brandCode: "",
        engineKeys: [],
        engineValues: [],
        gearboxKeys: [],
        gearboxValues: [],
        id: "",
        keys: [],
        keysDesc: {},
        logo: "",
        modelName: "",
        remark: "",
        title: [],
        values: [],
        vinCode: ""
      }
    };
  },
  mounted() {
    const query = this.$route.query || {};
    this.vin = String(query.vin || "");
    this.vmid = String(query.vmid || "");
    this.service = String(query.service || "");
    this.queryData = query;
    this.getEpcVehicleModelDetail();
  },
  methods: {
    changeConfigNavActive(item, i) {
      this.isChangeConfigNavActive = true;
      this.configNavActive = item.id;
      if (this.$refs.configContentTableRef) {
        this.$refs.configContentTableRef.scrollTop = this.configTableTHOffsetTop[i];
      }
      setTimeout(() => {
        this.isChangeConfigNavActive = false;
      }, 500);
    },
    scrollConfigTable(e) {
      if (this.isChangeConfigNavActive) {
        return;
      }
      const scrollTop = e.target.scrollTop;
      let index = this.configTableTHOffsetTop.findIndex(item => item > scrollTop + 300);
      if (index === -1) {
        index = this.configNavList.length;
      }
      this.configNavActive = this.configNavList[index - 1].id;
    },
    getConfigTableTHOffsetTop() {
      setTimeout(() => {
        for (const item of this.configNavList) {
          const thEv = document.getElementById(item.id);
          this.configTableTHOffsetTop.push(thEv?.offsetTop);
        }
      }, 500);
    },
    getEpcVehicleModelDetail() {
      const data = {
        ...this.queryData,
        vin: this.vin,
        vmid: this.vmid,
        service: this.service
      };
      this.loading = true;
      vehicleModelApi(data)
        .then(res => {
          this.loading = false;
          this.vehModelDetail = res;
          this.configNavActive = this.configNavList[0].id;
          // 处理数据
          const configTableList = this.configTable.filter(item => item.id);
          const nav1Content = [];
          const nav2Content = [];
          const nav3Content = [];
          const nav4Content = [];
          // 描述
          const keysDesc = this.vehModelDetail.keysDesc || {};
          // 基本参数
          const nav1ListValue = this.vehModelDetail.values;
          const nav1ListTitle = this.vehModelDetail.keys;
          if (nav1ListValue && nav1ListValue.length) {
            for (let i = 0; i < nav1ListValue.length; i++) {
              const contentObj = {
                type: "content",
                list: []
              };
              contentObj.list.push({
                type: "title",
                name: nav1ListTitle[i],
                tips: keysDesc[nav1ListTitle[i]] || ""
              });
              contentObj.list.push({
                type: "content",
                name: nav1ListValue[i] || "--"
              });
              if (nav1ListValue[i + 1] !== undefined) {
                contentObj.list.push({
                  type: "title",
                  name: nav1ListTitle[i + 1],
                  tips: keysDesc[nav1ListTitle[i + 1]] || ""
                });
                contentObj.list.push({
                  type: "content",
                  name: nav1ListValue[i + 1] || "--"
                });
              } else {
                contentObj.list.push({
                  type: "title",
                  name: "",
                  tips: ""
                });
                contentObj.list.push({
                  type: "content",
                  name: ""
                });
              }
              nav1Content.push(contentObj);
              i += 1;
            }
          }
          // 车身参数
          const nav2ListValue = this.vehModelDetail.bodyValues;
          const nav2ListTitle = this.vehModelDetail.bodyKeys;
          if (nav2ListValue && nav2ListValue.length) {
            for (let i = 0; i < nav2ListValue.length; i++) {
              const contentObj = {
                type: "content",
                list: []
              };
              contentObj.list.push({
                type: "title",
                name: nav2ListTitle[i],
                tips: keysDesc[nav2ListTitle[i]] || ""
              });
              contentObj.list.push({
                type: "content",
                name: nav2ListValue[i] || "--"
              });
              if (nav2ListValue[i + 1] !== undefined) {
                contentObj.list.push({
                  type: "title",
                  name: nav2ListTitle[i + 1],
                  tips: keysDesc[nav2ListTitle[i + 1]] || ""
                });
                contentObj.list.push({
                  type: "content",
                  name: nav2ListValue[i + 1] || "--"
                });
              } else {
                contentObj.list.push({
                  type: "title",
                  name: "",
                  tips: ""
                });
                contentObj.list.push({
                  type: "content",
                  name: ""
                });
              }
              nav2Content.push(contentObj);
              i += 1;
            }
          }
          // 发动机参数
          const nav3ListValue = this.vehModelDetail.engineValues;
          const nav3ListTitle = this.vehModelDetail.engineKeys;
          if (nav3ListValue && nav3ListValue.length) {
            for (let i = 0; i < nav3ListValue.length; i++) {
              const contentObj = {
                type: "content",
                list: []
              };
              contentObj.list.push({
                type: "title",
                name: nav3ListTitle[i],
                tips: keysDesc[nav3ListTitle[i]] || ""
              });
              contentObj.list.push({
                type: "content",
                name: nav3ListValue[i] || "--"
              });
              if (nav3ListValue[i + 1] !== undefined) {
                contentObj.list.push({
                  type: "title",
                  name: nav3ListTitle[i + 1],
                  tips: keysDesc[nav3ListTitle[i + 1]] || ""
                });
                contentObj.list.push({
                  type: "content",
                  name: nav3ListValue[i + 1] || "--"
                });
              } else {
                contentObj.list.push({
                  type: "title",
                  name: "",
                  tips: ""
                });
                contentObj.list.push({
                  type: "content",
                  name: ""
                });
              }
              nav3Content.push(contentObj);
              i += 1;
            }
          }
          // 变速箱/底盘/车轮配置
          const nav4ListValue = this.vehModelDetail.gearboxValues;
          const nav4ListTitle = this.vehModelDetail.gearboxKeys;
          if (nav4ListValue && nav4ListValue.length) {
            for (let i = 0; i < nav4ListValue.length; i++) {
              const contentObj = {
                type: "content",
                list: []
              };
              contentObj.list.push({
                type: "title",
                name: nav4ListTitle[i],
                tips: keysDesc[nav4ListTitle[i]] || ""
              });
              contentObj.list.push({
                type: "content",
                name: nav4ListValue[i] || "--"
              });
              if (nav4ListValue[i + 1] !== undefined) {
                contentObj.list.push({
                  type: "title",
                  name: nav4ListTitle[i + 1],
                  tips: keysDesc[nav4ListTitle[i + 1]] || ""
                });
                contentObj.list.push({
                  type: "content",
                  name: nav4ListValue[i + 1] || "--"
                });
              } else {
                contentObj.list.push({
                  type: "title",
                  name: "",
                  tips: ""
                });
                contentObj.list.push({
                  type: "content",
                  name: ""
                });
              }
              nav4Content.push(contentObj);
              i += 1;
            }
          }
          // 设置数据
          const nav1Index = configTableList.findIndex(item => item.id === "nav1") + 1;
          configTableList.splice(nav1Index, 0, ...nav1Content);
          const nav2Index = configTableList.findIndex(item => item.id === "nav2") + 1;
          configTableList.splice(nav2Index, 0, ...nav2Content);
          const nav3Index = configTableList.findIndex(item => item.id === "nav3") + 1;
          configTableList.splice(nav3Index, 0, ...nav3Content);
          const nav4Index = configTableList.findIndex(item => item.id === "nav4") + 1;
          configTableList.splice(nav4Index, 0, ...nav4Content);
          this.configTable = configTableList;
          this.getConfigTableTHOffsetTop();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.vehicle-config-details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #333;
  padding: 20px;
  background-color: #f5f7fa;
  box-sizing: border-box;

  .header-section {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }

  .config-content-title1 {
    font-size: 20px;
    font-weight: 600;
    color: #303133;
  }

  .config-content-title2 {
    font-size: 16px;
    font-weight: 500;
    color: #606266;
  }

  .config-content-title3 {
    font-size: 14px;
    color: #909399;
    padding: 8px 12px;
    background-color: #f0f9ff;
    border-radius: 4px;
    border-left: 3px solid #02a7f0;
  }

  .content-wrapper {
    display: flex;
    flex: 1;
    overflow: hidden;
    gap: 20px;
  }

  .config-nav {
    width: 220px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    overflow: hidden;
  }

  .config-nav-item {
    cursor: pointer;
    padding: 16px 20px;
    position: relative;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background-color: #f5f7fa;
      color: #02a7f0;
    }

    .nav-indicator {
      width: 4px;
      height: 0;
      background-color: #02a7f0;
      border-radius: 2px;
      transition: height 0.3s ease;
    }
  }

  .config-nav-item-active {
    color: #02a7f0;
    font-weight: 600;
    background-color: #f0f9ff;

    .nav-indicator {
      height: 20px;
    }
  }

  .config-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 20px;
  }

  .config-content-table {
    flex: 1;
    overflow: auto;

    table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;

      tr {
        transition: background-color 0.2s ease;

        &:nth-child(even) {
          background-color: #fafafa;
        }

        &:hover {
          background-color: #f5f7fa;
        }
      }

      tr th,
      tr td {
        padding: 12px 16px;
        border-bottom: 1px solid #e4e7ed;
        border-right: 1px solid #e4e7ed;
        text-align: left;

        &:last-child {
          border-right: none;
        }
      }

      tr:last-child th,
      tr:last-child td {
        border-bottom: none;
      }

      th {
        background-color: #f5f7fa;
        font-weight: 600;
        color: #303133;
      }

      .title {
        background-color: #f5f7fa;
        text-align: right;
        font-weight: 500;
        color: #606266;
        width: 180px;
      }

      tr td:nth-child(1),
      tr td:nth-child(3) {
        width: 180px;
      }
    }
  }

  .no-data-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #c0c4cc;

    .no-data-text {
      font-size: 18px;
      margin-top: 16px;
      color: #c0c4cc;
    }
  }

  .mt-2 {
    margin-top: 8px;
  }

  .mr-2 {
    margin-right: 8px;
  }

  .ml-2 {
    margin-left: 8px;
  }
}

/* 滚动条样式 */
.config-content-table::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.config-content-table::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.config-content-table::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.config-content-table::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
